import { Component, Inject } from "@angular/core";
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef
} from "@angular/material/bottom-sheet";

import { MembershipBenefitInterface } from "src/app/share/interface/motor.interface";

export interface DrivePlusBottomsheetData {
  tiers: any[];
  allBenefits: MembershipBenefitInterface[];
  /** Tier to open on. */
  selectedCode: string;
  originalRoadTaxPrice: number;
  /** "insurance" or "takaful", for the protectionPlan benefit strings. */
  protectionPlanWording: string;
}

export type DrivePlusBottomsheetAction = "confirm" | "decline";

export interface DrivePlusBottomsheetResult {
  action: DrivePlusBottomsheetAction;
  /** Tier the customer had selected when they acted. */
  tier: any;
}

/**
 * Mobile confirmation drawer for Drive+.
 *
 * Deliberately takes a plain view-model in and returns a plain result out - no
 * callbacks in `data` - so it stays decoupled from the add-ons page. The page
 * decides what confirm/decline mean for selection and pricing.
 */
@Component({
  selector: "app-driveplus-bottomsheet",
  templateUrl: "./driveplus-bottomsheet.component.html",
  styleUrls: ["./driveplus-bottomsheet.component.scss"]
})
export class DrivePlusBottomsheetComponent {
  /** Tier currently shown; the customer can switch it inside the drawer. */
  selectedCode: string;

  /** The vehicle-eligibility confirmation. Confirm stays disabled until ticked. */
  confirmed = false;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: DrivePlusBottomsheetData,
    private bottomSheetRef: MatBottomSheetRef<DrivePlusBottomsheetComponent>
  ) {
    this.selectedCode = data?.selectedCode ?? data?.tiers?.[0]?.code;
  }

  get selectedTier(): any {
    return (
      this.data?.tiers?.find((t) => t?.code === this.selectedCode) ??
      this.data?.tiers?.[0] ??
      null
    );
  }

  get confirmPrice(): number {
    const parsed = Number.parseFloat(String(this.selectedTier?.evaluate ?? ""));
    return Number.isFinite(parsed) ? parsed : 0;
  }

  onTierChange(tier: any): void {
    this.selectedCode = tier?.code;
  }

  confirm(): void {
    if (!this.confirmed) return;
    this.dismiss("confirm");
  }

  decline(): void {
    this.dismiss("decline");
  }

  private dismiss(action: DrivePlusBottomsheetAction): void {
    const result: DrivePlusBottomsheetResult = {
      action,
      tier: this.selectedTier
    };
    this.bottomSheetRef.dismiss(result);
  }
}
